import { render, staticRenderFns } from "./DifficultyModal.vue?vue&type=template&id=71f19eda&scoped=true"
import script from "./DifficultyModal.vue?vue&type=script&lang=js"
export * from "./DifficultyModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71f19eda",
  null
  
)

export default component.exports